import { useEffect, useRef,useState} from "react";
import { getToken, getUserId } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,ordinaPerData,convertiCambi,prendiNomePacchetto,coloreDaId,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX, faPencil, faTrashCan,faCircleInfo,faSpinner,faChartSimple } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
/* global $ */
function Equipment() {
let utilizzi={}
function prepareDataSource(data) {
  const weeklyData = {};

  function getWeekStartString(dateStr) {
    const y = parseInt(dateStr.slice(0, 4), 10);
    const m = parseInt(dateStr.slice(4, 6), 10) - 1;
    const d = parseInt(dateStr.slice(6, 8), 10);
    const date = new Date(Date.UTC(y, m, d));
    const day = date.getUTCDay(); // 0 (Sun) to 6 (Sat)
    const diff = date.getUTCDate() - day + (day === 0 ? -6 : 1); // Monday as first day
    date.setUTCDate(diff);
    return date.toISOString().slice(0, 10);
  }

  for (const dateStr in data) {
    const week = getWeekStartString(dateStr);
    const items = data[dateStr];

    if (!weeklyData[week]) weeklyData[week] = {};

    for (const item in items) {
      weeklyData[week][item] = (weeklyData[week][item] || 0) + items[item];
    }
  }

  // Convert to array format
  const dataSource = Object.entries(weeklyData).map(([week, usage]) => ({
    week,
    ...usage
  }));

  return dataSource;
}

async function mostraDettagliArticolo(id) {
    let oreDiVoloNol=0
    let oreDiVoloLez=0
    const noleggi= await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: "getRentals",
                        childs: ["inventories"],
                    })
    const lezioni = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: {lessondatestatus:2 },
    childs: ["inventories"],
  })
  const utenti=await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getUsers",
  })
  const pacchetti = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessons",
  })
  const escursioni=await funzione_collegamento({
    userid:getUserId(),
    token:getToken(),
    azione:"getExcursions",
    })
    const escursioni_mat= await funzione_collegamento({
    userid:getUserId(),
    token:getToken(),
    azione:"getLinkExcInvs",
    })
  const periodi = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getUserWorkPeriods'})
  let datiCambi = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExchanges",
                filtri:{"exchangerates":"USDEUR"+","+"USDKES"},
                })
  datiCambi=convertiCambi(datiCambi,["EURKES"])
  let formattedRowsNoleggi=[]
  let guadagnoLezioni=0
  let guadagnoNoleggi=0
  let guadagnoEscursioni=0
  for (let noleggio of noleggi){
    let oreTot=0
    for (let materiale of noleggio["inventories"]){
        if ((noleggio.rentaltype===1 && materiale.inventorytype===1) || (noleggio.rentaltype===2  && materiale.inventorytype===1) ||(noleggio.rentaltype!==1 && noleggio.rentaltype!==2 &&(materiale.inventorytype===3 ||materiale.inventorytype===4 || materiale.inventorytype===5))){
            oreTot+=(convertDate(materiale.rentinvlinkto) - convertDate(materiale.rentinvlinkfrom))
        }
    }
    for (let materiale of noleggio["inventories"]){
        if (parseInt(materiale.inventoryid)===parseInt(id)){
            formattedRowsNoleggi=[...formattedRowsNoleggi,{"cliente":noleggio.rentalcustname,"inizio":convertDate(materiale.rentinvlinkfrom),"fine":convertDate(materiale.rentinvlinkto),"durata":convertDate(materiale.rentinvlinkto) - convertDate(materiale.rentinvlinkfrom)}]
            if ((convertDate(materiale.rentinvlinkto) - convertDate(materiale.rentinvlinkfrom))<8*60*60*1000){
                oreDiVoloNol+=(convertDate(materiale.rentinvlinkto) - convertDate(materiale.rentinvlinkfrom))
                guadagnoNoleggi+=((convertDate(materiale.rentinvlinkto) - convertDate(materiale.rentinvlinkfrom))/oreTot)*(noleggio.rentalcost * (1 - (noleggio.rentaldiscount || 0) / 100))
            }
        }
    }
  }
  let formattedRowsLezioni=[]
  for (let lezione of lezioni){
    for (let materiale of lezione["inventories"]){
        if (parseInt(materiale.inventoryid)===parseInt(id)){
            for (let pacchetto of pacchetti){
                if (lezione.lessonid===pacchetto.lessonid){
                    formattedRowsLezioni=[...formattedRowsLezioni,{"cliente":pacchetto.lessonstudentname,"inizio":convertDate(lezione.lessondatestart),"fine":convertDate(lezione.lessondateend),"durata":convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart),"istruttore":nome_id({id:lezione.userid,utenti:utenti})}]
                    oreDiVoloLez+=((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart)))
                    let stipendioLezione=0
                    for (let utente of utenti){
                        if (utente.userid===lezione.userid){
                            for (let periodo of periodi){
                                if (periodo.userid===utente.userid && (DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))){
                                    if (utente.type!==5 || pacchetto.type==="Base"){
                                        let paga=0
                                        if (periodo.workperiodfixedsalarycurrency===0){
                                            if (pacchetto.lessonnumstudents===1){
                                                paga=periodo.workperiodhourlypayment
                                            }
                                            else
                                            paga=periodo.workperiodhourlypaymentgroups
                                        }
                                        else{
                                            const data=DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"}).toFormat("yyyyMMdd")
                                            if (pacchetto.lessonnumstudents===1)
                                            paga=periodo.workperiodhourlypayment/datiCambi[data]
                                            else
                                            paga=periodo.workperiodhourlypaymentgroups/datiCambi[data]
                                        }
                                        guadagnoLezioni+=((((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart))/(3600*1000))/pacchetto.lessonpacket)*(pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100)))-((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart))/(3600*1000))*paga
                                            //console.log(((((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart))/(3600*1000))/pacchetto.lessonpacket)*(pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100)))-((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart))/(3600*1000))*paga,paga)

                                    }
                                    else{
                                        //console.log(((((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart))/(3600*1000))/pacchetto.lessonpacket)*(pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100)))*(1 - periodo.workperiodcommissionratelessonmaterial/100),"comm")
                                        guadagnoLezioni+=((((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart))/(3600*1000))/pacchetto.lessonpacket)*(pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100)))*(1 - periodo.workperiodcommissionratelessonmaterial/100)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
  }
  //console.log(guadagnoLezioni,guadagnoNoleggi)
  const divGen = document.createElement("div");
  divGen.style.padding = "0px";
  divGen.style.height="100%"
  const noleggiGen=document.createElement("div");
  const noleggiDiv = document.createElement("div");
  noleggiDiv.id = "gridContainerRent";
  const noleggiTitolo=document.createElement("h2");
  noleggiTitolo.innerText="Utilizzo in noleggi"
  noleggiTitolo.style.fontFamily="Poppins, sans-serif"
  noleggiTitolo.style.fontWeight="bold"
  noleggiTitolo.style.margin="0px"
  noleggiGen.appendChild(noleggiTitolo)
  noleggiGen.appendChild(noleggiDiv);
  divGen.appendChild(noleggiGen);
  const lezioniGen=document.createElement("div");
  const lezioniDiv = document.createElement("div");
  lezioniDiv.id = "gridContainerLes";
  const lezioniTitolo=document.createElement("h2");
  lezioniTitolo.innerText="Utilizzo in Lezioni"
  lezioniTitolo.style.fontFamily="Poppins, sans-serif"
  lezioniTitolo.style.fontWeight="bold"
  lezioniTitolo.style.marginTop="10px"
  lezioniGen.appendChild(lezioniTitolo)
  lezioniGen.appendChild(lezioniDiv);
  divGen.appendChild(lezioniGen);
  const commento = document.createElement("p");
  commento.innerText = `Ore totali di utilizzo: ${differenzaOrario({dataInizio:oreDiVoloNol + oreDiVoloLez})}, di cui ${oreDiVoloNol?differenzaOrario({dataInizio:oreDiVoloNol}):0} di noleggi e ${oreDiVoloLez?differenzaOrario({ dataInizio:oreDiVoloLez}):0} di lezioni`
  commento.style.marginTop = "10px";
  commento.style.fontWeight = "bold";
  commento.style.fontSize = "22px";
  commento.style.fontFamily = "Poppins, sans-serif";

  const commento2 = document.createElement("p");
  commento2.innerText = `Guadagno totale del kite: ${(guadagnoNoleggi+guadagnoLezioni).toFixed(2)}€, di cui ${(guadagnoNoleggi).toFixed(2)}€ da noleggi e ${(guadagnoLezioni).toFixed(2)}€ da lezioni`
  commento2.style.marginTop = "10px";
  commento2.style.fontSize = "22px";
  commento2.style.fontFamily = "Poppins, sans-serif";
  divGen.appendChild(commento2);
  divGen.appendChild(commento);
  setTimeout(() =>{
    $("#gridContainerRent").dxDataGrid({
        dataSource:formattedRowsNoleggi,
        columns:[
            {dataField:"cliente",caption:"Cliente noleggio",alignment:"center",},
            {dataField:"inizio",caption:"Inizio noleggio",customizeText:function(e){return e.value.toFormat('dd/MM/yyyy, HH:mm')},alignment:"center",},
            {dataField:"fine",caption:"Fine noleggio",customizeText:function(e){return e.value.toFormat('dd/MM/yyyy, HH:mm')},alignment:"center",},
            {dataField:"durata",caption:"Durata noleggio",customizeText:function(e){return differenzaOrario({dataInizio:e.value})},alignment:"center",}
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 5 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Cerca...',
        },

    })
    $("#gridContainerLes").dxDataGrid({
        dataSource:formattedRowsLezioni,
        columns:[
            {dataField:"cliente",caption:"Studente",alignment:"center",},
            {dataField:"inizio",caption:"Inizio lezione",customizeText:function(e){return e.value.toFormat('dd/MM/yyyy, HH:mm')},alignment:"center",},
            {dataField:"fine",caption:"Fine lezione",customizeText:function(e){return e.value.toFormat('dd/MM/yyyy, HH:mm')},alignment:"center",},
            {dataField:"durata",caption:"Durata lezione",customizeText:function(e){return differenzaOrario({dataInizio:e.value})},alignment:"center",},
            {dataField:"istruttore",caption:"Istruttore",alignment:"center",}
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 5 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Cerca...',
        },

    })
  },0)
return divGen
}
function DynamicLessonButton({materiale}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);
          const content = await mostraDettagliArticolo(materiale.inventoryid)

          $("#loadingOverlay").hide();  // Nasconde overlay
            setLoading(false);
          $("#infoMateriale").dxPopup("instance").option(
            "title",
            `Dettagli utilizzo di ${materiale.inventorybrand} ${materiale.inventorymeasure} ${materiale.inventorydescr} ${materiale.inventoryyear} ${materiale.inventorynotes ? materiale.inventorynotes : ""}`
          );
          $("#infoMateriale").dxPopup("instance").option("contentTemplate", () => content);
          $("#infoMateriale").dxPopup("instance").show();
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faChartSimple}
       className={loading ? 'spin-icon' : ''}
      color="#03a9f4"
      onClick={loading ? null : handleClick}
    />
  );
}

function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
const Equipment = () => {
  const gridRef = useRef(null);
  const allineamento="center"
  useEffect(() => {
  $("#loadingOverlay").show();
    const fetchPacchetti = async () => {
       const noleggi= await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: "getRentals",
                        childs: ["inventories"],
                    })
    const lezioni = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: {lessondatestatus:2 },
    childs: ["inventories"],
  })

      $("#gridContainer").addClass("grid-container-hidden")
      const data = await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getInventoryItems'
      });

      const formattedRows = data.map((row, index) => ({
        id: index,
        inventoryid:row.inventoryid,
        marca: row.inventorybrand,
        misura: row.inventorymeasure,
        tipo: row.inventorytype,
        modello: row.inventorydescr,
        note: row.inventorynotes,
        utilizzabile: row.inventoryusable,
        anno:row.inventoryyear
      }));
      // Inizializza dxDataGrid
      $("#gridContainer").dxDataGrid({
        dataSource: formattedRows,
        columns: [
        { dataField: "tipo", caption: "Tipo materiale", alignment:allineamento,hidingPriority: 2,editCellTemplate: function(cellElement,cellInfo) {
          if ($("#val_tipo").length===0) {
                $('<div id="val_tipo"></div>').appendTo(cellElement)
            }
          let dataTipo = [];
          for (let i = 1; i <= 5; i++) {
            dataTipo.push({ ID: i, nome: convertiIdInventario(i) });
          }
          $("#val_tipo").dxSelectBox({dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',value:cellInfo.value,searchEnabled: true, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            },
            })
          },
          customizeText: function (e){
             return convertiIdInventario(e.value)
          }
          },

          { dataField: "marca", caption: "Brand", hidingPriority: 3,alignment:allineamento, },
          {
            dataField: "misura",
            hidingPriority: 7,
            caption: "Misura",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_pacchetto").length===0) {
                $('<div id="val_pacchetto"></div>').appendTo(cellElement)
            }
            if (!isNaN(Number(cellInfo.value)) && cellInfo.value.trim() !== ""){$("#val_pacchetto").dxNumberBox({min:0,step:1,value:  parseInt(cellInfo.value) ,format:"#' m'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})}
            else{
            $("#val_pacchetto").dxTextBox({value:cellInfo.value, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})}
          },
            customizeText: function (e) {
              return `${e.value}m`;}
          },

          {
            dataField: "modello",
            hidingPriority: 6,
            caption: "Modello",
            alignment:allineamento,
            editorType: "dxTextBox", // Cambia in dxNumberBox per un input numerico

          },
          {dataField: "note", caption: "Note", hidingPriority: 4,alignment:allineamento,},
          { dataField: "anno", caption: "Anno", hidingPriority: 5,alignment:allineamento, },
          {
          dataField:"utilizzabile", caption:"Utilizzabile",hidingPriority: 1,alignment:allineamento,
          editCellTemplate: function(cellElement,cellInfo) {
          if ($("#val_util").length===0) {
                $('<div id="val_util"></div>').appendTo(cellElement)
            }
          $("#val_util").dxCheckBox({value:cellInfo.value, onValueChanged: function(e) {
            if (e.value)
            cellInfo.setValue(1)
            else
            cellInfo.setValue(0)
            },
            })
          },

          cellTemplate: (cellElement, cellInfo) => {
              const icon = cellInfo.value === 1 ? faCheck : faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );
            },
          },
          {
            type: "buttons",
            width:"120px",
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#03a9f4"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                  hint: "Dettagli utilizzo materiale",
                  icon: "none",
                  template: function (cellElement, cellInfo) {
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(<DynamicLessonButton materiale={data[cellInfo.data.id]} />);
                  },
              }
            ],
          },
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica articolo",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                  {
                    dataField: "tipo",
                    label: { text: "Categoria materiale" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "marca",
                    label: { text: "Brand materiale" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "misura",
                    label: { text: "Dimensioni materiale" }  // ← Etichetta personalizzata
                  },
                   {
          dataField: "modello",
          label: {
            text: "Modello materiale",
          }
        },
        {
          dataField: "anno",
          label: {
            text: "Anno materiale",
          }
        },
        {
          dataField: "utilizzabile",
          label: {
            text: "Materiale utilizzabile",
          }
        }
                ],
              },
        {
                itemType: "group",
                colCount: 1,
                colSpan: 2,
                items: [{
          dataField: "note",
          label: {
            text: "Note Materiale",
          }
        }]}
            ],
          },
        },
        onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

  const masterRow = e.component.getRowElement(e.row.rowIndex);
  const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
  if (!($icon.length)) {
  const masterRow = e.component.getRowElement(e.row.rowIndex);
  const $icon = masterRow.find(".dx-datagrid-adaptive-more");
  if ($icon.length){
  $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
  }
  else
  {
  $icon[0].className = "dx-datagrid-adaptive-more";
  }}

},
    onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
          let dataTipo = [];
          for (let i = 1; i <= 5; i++) {
            dataTipo.push({ ID: i, nome: convertiIdInventario(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            };
          }
        },
    onRowRemoving: async function (e) {
    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.inventoryid,
        azione:'delInventoryItem',
        return_data:false})
    if (richiesta) {
        const message = `Articolo eliminato con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);}


},

    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainer").addClass("grid-container-hidden");

        // Rimuovi la classe dopo l'animazione

    const dati_n={'inventoryid':e.data.inventoryid,'inventorybrand':e.data.marca,'inventorytype':e.data.tipo,'inventorydescr':e.data.modello,'inventoryyear':e.data.anno,'inventorymeasure':e.data.misura,'inventoryusable':e.data.utilizzabile,"inventorynotes":e.data.note};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati_n,
        azione:'setInventoryItem'})
    if (richiesta) {
        const message = `Articolo aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
        const data = await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getInventoryItems'
      });

      const formattedRows = data.map((row, index) => ({
        id: index,
        inventoryid:row.inventoryid,
        marca: row.inventorybrand,
        misura: row.inventorymeasure,
        tipo: row.inventorytype,
        modello: row.inventorydescr,
        note: row.inventorynotes,
        utilizzabile: row.inventoryusable,
        anno:row.inventoryyear
      }));
      e.component.option("dataSource", formattedRows);
      setTimeout(() => {
            $("#gridContainer").removeClass("grid-container-hidden");
            $("#loadingOverlay").hide();
        }, 100);
        }
    },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainer"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    const dati_n={'inventoryid':e.data.inventoryid,'inventorybrand':e.data.marca,'inventorytype':e.data.tipo,'inventorydescr':e.data.modello,'inventoryyear':e.data.anno,'inventorymeasure':e.data.misura,'inventoryusable':e.data.utilizzabile,};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.inventoryid,
        valori:dati_n,
        azione:'setInventoryItem'})
        if (richiesta) {
        const message = `Articolo modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
        }
    },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainer").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)

        },
      });
    function fetchUtilizzi(tabs2,istogramma){
    if (istogramma===0){
        let utiliprovNol={}
        let utiliprovLez={}
        utilizzi={}
        let stringa=""
        for (let lezione of lezioni){
        for (let materiale of lezione["inventories"]){
            if (!(materiale.inventorytype in utiliprovLez)){utiliprovLez[materiale.inventorytype]={}}

            if (tabs2==0)
             stringa=`${materiale.inventorybrand} ${materiale.inventorymeasure} ${materiale.inventorydescr}`
            else stringa=`${materiale.inventorymeasure}`
            if (!(stringa in utiliprovLez[materiale.inventorytype])){utiliprovLez[materiale.inventorytype][stringa]=0}
            utiliprovLez[materiale.inventorytype][stringa]+=((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart)))
        }
      }
      for (let noleggio of noleggi){
        for (let materiale of noleggio["inventories"]){
            if (!(materiale.inventorytype in utiliprovNol)){utiliprovNol[materiale.inventorytype]={}}
            if (tabs2==0)
             stringa=`${materiale.inventorybrand} ${materiale.inventorymeasure} ${materiale.inventorydescr}`
            else stringa=`${materiale.inventorymeasure}`
            if (!(stringa in utiliprovNol[materiale.inventorytype])){utiliprovNol[materiale.inventorytype][stringa]=0}
            utiliprovNol[materiale.inventorytype][stringa]+=((convertDate(materiale.rentinvlinkto) - convertDate(materiale.rentinvlinkfrom)))
        }
      }

      for (let i in utiliprovNol){
        if (!(i in utilizzi)){utilizzi[i]=[]}
        for (let materiali in utiliprovNol[i]){
            let totalLezz=0
            for (let materialiLez in utiliprovLez[i] ){
                if (materiali===materialiLez){
                    totalLezz=utiliprovLez[i][materiali]
                }
            }
            utilizzi[i]=[...utilizzi[i],{materiale:materiali,totaleNol:utiliprovNol[i][materiali],totaleLez:totalLezz}]
        }
      }
      for (let i in utiliprovLez){
        if (!(i in utilizzi)){utilizzi[i]=[]}
        for (let materiali in utiliprovLez[i]){
            let totalLezz=0
            for (let materialiLez in utiliprovNol[i] ){
                if (materiali===materialiLez){
                    totalLezz=utiliprovNol[i][materiali]
                }
            }
            let cegia=false
            for (let k of utilizzi[i]){if (k.materiale===materiali){;cegia=true}}
            if (!cegia){
            utilizzi[i]=[...utilizzi[i],{materiale:materiali,totaleLez:utiliprovLez[i][materiali],totaleNol:totalLezz}]}
        }
      }
      for (let i = 1; i <= 5; i++ ){
      utilizzi[i].sort((a, b) => {

        const getSize = (str) => {
            const parts = str.split(' ');
            return parseInt(parts[1]) || 0;
        };
        if (tabs2===0){
        return getSize(a.materiale) - getSize(b.materiale);}
        else {
        return parseInt(a.materiale) - parseInt(b.materiale)
        }});}
        }
    else {
        let utilizzo={}
        let stringa=""
        for (let noleggio of noleggi){
            for (let materiale of noleggio["inventories"]){
                if (materiale.rentinvlinkfrom.slice(0,8)===materiale.rentinvlinkto.slice(0,8)){
                    if (!(materiale.inventorytype in utilizzo)) utilizzo[materiale.inventorytype]={}
                    if (!(materiale.rentinvlinkfrom.slice(0,8) in utilizzo[materiale.inventorytype])){utilizzo[materiale.inventorytype][materiale.rentinvlinkfrom.slice(0,8)]={}}
                    if (tabs2==0)
                     stringa=`${materiale.inventorybrand} ${materiale.inventorymeasure} ${materiale.inventorydescr}`
                    else stringa=`${materiale.inventorymeasure}`
                    if (!(stringa in utilizzo[materiale.inventorytype][materiale.rentinvlinkfrom.slice(0,8)])){utilizzo[materiale.inventorytype][materiale.rentinvlinkfrom.slice(0,8)][stringa]=0}
                    utilizzo[materiale.inventorytype][materiale.rentinvlinkfrom.slice(0,8)][stringa]+=((convertDate(materiale.rentinvlinkto) - convertDate(materiale.rentinvlinkfrom)))

                }
            }
        }
         stringa=""
        for (let lezione of lezioni){
            for (let materiale of lezione["inventories"]){
                if (lezione.lessondatestart.slice(0,8)===lezione.lessondateend.slice(0,8)){
                    if  (!(materiale.inventorytype in utilizzo)) utilizzo[materiale.inventorytype]={}
                    if (!(lezione.lessondatestart.slice(0,8) in utilizzo[materiale.inventorytype])){utilizzo[materiale.inventorytype][lezione.lessondatestart.slice(0,8)]={}}
                    if (tabs2==0)
                     stringa=`${materiale.inventorybrand} ${materiale.inventorymeasure} ${materiale.inventorydescr}`
                    else stringa=`${materiale.inventorymeasure}`
                    if (!(stringa in utilizzo[materiale.inventorytype][lezione.lessondatestart.slice(0,8)])){utilizzo[materiale.inventorytype][lezione.lessondatestart.slice(0,8)][stringa]=0}
                    utilizzo[materiale.inventorytype][lezione.lessondatestart.slice(0,8)][stringa]+=((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart)))

                }
            }
        }
        for (let i = 1; i <= 5; i++) {
        utilizzo[i]=prepareDataSource(utilizzo[i])}
        utilizzi=utilizzo
    }
  return utilizzi
    }
  $("#chartElement").dxChart({
    dataSource: [],  // <-- il tuo array con i millisecondi
    commonSeriesSettings: {
        argumentField: "materiale",
        type: "stackedBar"
    },
    series: [{
        valueField: "totaleLez",
        name: "Lezioni",
        label: {
            visible: false,
            customizeText: function (pointInfo) {
                return differenzaOrario({dataInizio:pointInfo.value})
            }
        }
    },
    {
        valueField: "totaleNol",
        name: "Noleggi",
        label: {
            visible: false,
            customizeText: function (pointInfo) {
                return differenzaOrario({dataInizio:pointInfo.value})
            }
        }
    },
    ],
    valueAxis: {
        tickInterval: 1000*60*60*10,
        label: {
            customizeText: function (axisInfo) {
                return differenzaOrario({ dataInizio: axisInfo.value });
            }
        }
    },
    onLegendClick(e) {
      const series = e.target;
      if (series.isVisible()) {
        series.hide();
      } else {
        series.show();
      }},
    tooltip: {
      enabled: true,
      location: 'edge',
      customizeTooltip: function (pointInfo) {
      return {
            html:
            "<b>Materiale:</b> " + pointInfo.argumentText + "<br>" +
                  `<b>Durata ${pointInfo.seriesName}: </b>` + differenzaOrario({ dataInizio: pointInfo.value })+"<br>" +
             `<b>Percentuale</b>: ${pointInfo.percentText}. <b>Tempo di utilizzo totale:</b> ${differenzaOrario({ dataInizio: pointInfo.total })}`
        };
      },
    },
});
    let dataTipo = [];
  for (let i = 1; i <= 5; i++) {
    dataTipo.push({ ID: i, nome: convertiIdInventario(i) });
  }
  $("#valoriGrafico").dxSelectBox({dataSource:dataTipo,valueExpr: 'ID',value:1,displayExpr: 'nome',searchEnabled: true,
  width: "300px",
  onValueChanged: function(ev) {
    $("#chartElement").dxChart("instance").option("dataSource",utilizzi[ev.value])
    if (tabs.option("selectedIndex")===1){
      const weekData = utilizzi[$("#valoriGrafico").dxSelectBox("instance").option("value")];

  const allKeys = new Set();
  weekData.forEach(entry => {
    Object.keys(entry).forEach(key => {
      if (key !== "week") allKeys.add(key);
    });
  });

  const series = Array.from(allKeys).map(name => ({
    valueField: name,
    name,
    visible: false
  }));
  $("#chartElement").dxChart("instance").option("series",series)
      }
  }
  })
    const tabsIconAndText2 = [
      { id: 0, text: 'Modello'},
      { id: 1, text: 'Metratura'},
    ];
    const tabsIconAndText = [
      { id: 0, text: 'Ore totali'},
      { id: 1, text: 'Andamento temporale'},
    ];
    let tabs=null
    let tabs2=null
     tabs =$('#istoLinea').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {const newIndex = e.component.option("selectedIndex");
      if (tabs2)
      {utilizzi=fetchUtilizzi(tabs2.option("selectedIndex"),newIndex)
      if (newIndex === 1) {
      const div = document.getElementById("SpiegazioneGrafico");

// Crea un elemento <h3>
const titolo = document.createElement("h2");
titolo.textContent = "Seleziona l'articolo interessato dalla legenda";

// Aggiungilo all'inizio del div
div.prepend(titolo)
  const currentKey = $("#valoriGrafico").dxSelectBox("instance").option("value");
  const weekData = utilizzi[currentKey];

  const allKeys = new Set();
  weekData.forEach(entry => {
    Object.keys(entry).forEach(key => {
      if (key !== "week") allKeys.add(key);
    });
  });

  const series = Array.from(allKeys).map(name => ({
    valueField: name,
    name,
    visible: false
  }));
  $("#chartElement").dxChart("instance").option({
    commonSeriesSettings: {
      type: "line",
      argumentField: "week"
    },
    dataSource: weekData,
    series: series,
    argumentAxis: {
      argumentType: "datetime",
      label: { format: "dd/MM" }
    },
    tooltip: {
      enabled: true,
      location: 'edge',
      customizeTooltip: function (pointInfo) {
      return {
            html:
            "<b>Materiale:</b> " + pointInfo.seriesName+ "<br>" +
                          `<b>Utilizzo nella settimana del ${DateTime.fromJSDate(new Date(pointInfo.argument)).toFormat("dd/MM/yyyy")}: </b>` + differenzaOrario({ dataInizio: pointInfo.value })+"<br>" +
             `<b>Percentuale</b>: ${pointInfo.percentText}. <b>Tempo di utilizzo totale:</b> ${differenzaOrario({ dataInizio: pointInfo.total })}`
        };
      },
    },
  });
  $("#chartElement").css({
  marginBottom: "30px",
});

} else {
const div = document.getElementById("SpiegazioneGrafico");
const titolo = div.querySelector("h2");
if (titolo) {
  div.removeChild(titolo);
}
  const currentKey = $("#valoriGrafico").dxSelectBox("instance").option("value");
  const barData = utilizzi[currentKey];
  const $chart = $("#chartElement");
$chart.dxChart("dispose");
  $("#chartElement").dxChart({dataSource: barData,
    commonSeriesSettings: {
        argumentField: "materiale",
        type: "stackedBar"
    },
    series: [{
        valueField: "totaleLez",
        name: "Lezioni",
        label: {
            visible: false,
            customizeText: function (pointInfo) {
                return differenzaOrario({dataInizio:pointInfo.value})
            }
        }
    },
    {
        valueField: "totaleNol",
        name: "Noleggi",
        label: {
            visible: false,
            customizeText: function (pointInfo) {
                return differenzaOrario({dataInizio:pointInfo.value})
            }
        }
    },
    ],
    valueAxis: {
        tickInterval: 1000*60*60*10,
        label: {
            customizeText: function (axisInfo) {
                return differenzaOrario({ dataInizio: axisInfo.value });
            }
        }
    },
    onLegendClick(e) {
      const series = e.target;
      if (series.isVisible()) {
        series.hide();
      } else {
        series.show();
      }},
    tooltip: {
      enabled: true,
      location: 'edge',
      customizeTooltip: function (pointInfo) {
      return {
            html:
            "<b>Materiale:</b> " + pointInfo.argumentText + "<br>" +
                  `<b>Durata ${pointInfo.seriesName}: </b>` + differenzaOrario({ dataInizio: pointInfo.value })+"<br>" +
             `<b>Percentuale</b>: ${pointInfo.percentText}. <b>Tempo di utilizzo totale:</b> ${differenzaOrario({ dataInizio: pointInfo.total })}`
        };
      },
    },
});
$("#chartElement").css({
  marginBottom: "30px",
});
}

      }
      }
    }).dxTabs('instance');
    tabs.option("selectedIndex", 0)
     tabs2 =$('#concluseNo').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText2,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {const newIndex = e.component.option("selectedIndex");
      if (newIndex===0 || newIndex===1){
      utilizzi=fetchUtilizzi(newIndex,tabs.option("selectedIndex"))
      $("#chartElement").dxChart("instance").option("dataSource",utilizzi[$("#valoriGrafico").dxSelectBox("instance").option("value")])
      if (tabs.option("selectedIndex")===1){
      const weekData = utilizzi[$("#valoriGrafico").dxSelectBox("instance").option("value")];

  const allKeys = new Set();
  weekData.forEach(entry => {
    Object.keys(entry).forEach(key => {
      if (key !== "week") allKeys.add(key);
    });
  });

  const series = Array.from(allKeys).map(name => ({
    valueField: name,
    name,
    visible: false
  }));
  $("#chartElement").dxChart("instance").option("series",series)
      }
      }

    },
    }).dxTabs('instance');
    tabs2.option("selectedIndex", 0)
  utilizzi=fetchUtilizzi(tabs2.option("selectedIndex"),tabs.option("selectedIndex"))
    };

    fetchPacchetti();
    $("#infoMateriale").dxPopup({
    width: "80%",
    height: '90%',
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const popupHeight = e.component.option("height");
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    })}});

  }, []);

  return (

    <div id="gridContainer" ref={gridRef}></div>
  );
}
return (<div id="app" style={{ padding: "0px" }}>
    <h2>Gestione Inventario</h2>
    <Equipment/>
    <h2>Analisi ore di utilizzo</h2>
    <div id="istoLinea"></div>
    <div id="concluseNo" style={{ marginBottom: "15px" }}></div>
    <div id="valoriGrafico" style={{ marginBottom: "15px" }}></div>
    <div id="SpiegazioneGrafico"></div>
    <div id="chartElement" style={{ marginTop: "15px" ,marginBottom:"30px"}}></div>
    <div style={{padding:"30px"}} id="infoMateriale">
      <div className="popup-content">
      </div>
    </div>
    <div id="loadingOverlay">
      <div className="spinner">
        <Lottie  style={{ width: "250px", height: "250px" }} animationData={animLoading} loop={true} />
      </div>
    </div>
  </div>)
}
export default Equipment;